import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BusinessSlice, Business } from "./types";

import { RootState } from "lib/store";

const initialState: BusinessSlice | {} = {};

// Slice
export const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setBusinesses(state: BusinessSlice, action: PayloadAction<Business[]>) {
      state.businesses = action.payload;
    },
  },
});

export const { setBusinesses } = businessSlice.actions;

const selectSlice = (state: RootState) => state.businessSlice || initialState;

export const selectBusinesses = createSelector(
  [selectSlice],
  (state: BusinessSlice) => state.businesses
);

export default businessSlice.reducer;
